import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from 'components/layouts/InfoLayout';

const TermsAndConditions = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'Terms.path',
          defaultMessage: 'TERMS.md',
        })}
        skipHtml
      />
    </InfoLayout>
  );
};

export default TermsAndConditions;
